import { ActivityStatusType } from 'src/app/helpers/enums/settings/review-type/activityStatusType';

export const ActivityStatusTypeDetails = new Map<number, string>([
    [ActivityStatusType.NotStarted, 'Not Started'],
    [ActivityStatusType.EnRoute, 'En Route'],
    [ActivityStatusType.InProgress, 'In Progress'],
    [ActivityStatusType.Complete, 'Complete'],
    [ActivityStatusType.NeedsAction, 'Needs Action'],
]);
